import React, { FC, ReactNode, useState } from 'react'
import { useTheme } from '@shared/lib'
import { Flex, Icon } from '@shared/ui/atoms'

interface TooltipProps {
  isTooltipOpen: boolean
  handleSwitchTooltipIsOpen: () => void
}

interface MobileLabelWithTooltipProps {
  tooltip: ({ isTooltipOpen, handleSwitchTooltipIsOpen }: TooltipProps) => ReactNode
  onClick: ({ handleSwitchTooltipIsOpen }: Omit<TooltipProps, 'isTooltipOpen'>) => void
}

const MobileLabelWithTooltip: FC<MobileLabelWithTooltipProps> = ({ tooltip, onClick }) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false)

  const theme = useTheme()

  const handleSwitchTooltipIsOpen = () => {
    setIsTooltipOpen((prev) => !prev)
  }

  return (
    <Flex alignItems="center">
      Где искать
      <Icon
        onClick={() => onClick({ handleSwitchTooltipIsOpen })}
        icon="baseX16/question-circle"
        color={theme.colors.icon.tertiary}
        style={{ marginLeft: '4px' }}
      />
      {tooltip({ isTooltipOpen, handleSwitchTooltipIsOpen })}
    </Flex>
  )
}

export default MobileLabelWithTooltip
